import { Guest, GuestStatus } from "../types";
import { createGenericFormSlice, SliceState } from "./genericFormSlice";

interface Assignment {
  quantity: number;
  comment: string;
}

export interface ExpandedGuest extends Guest {
  primaryFirstName: string;
  primaryLastName: string;
  plusOnes: {
    id?: string;
    firstName: string;
    lastName?: string;
    email?: string;
    status?: GuestStatus;
  }[];
  // Key is the activityId
  assignments: { [key: string]: Assignment };
  canUserEdit: boolean;
}

const formSlice = createGenericFormSlice({
  name: "guestTab",
  initialState: {} as SliceState<ExpandedGuest>,
  reducers: {},
});

export const { reset, initialize, updateField } = formSlice.actions;
const guestTabReducer = formSlice.reducer;
export default guestTabReducer;
